var _a;
import { __rest } from "tslib";
const wreply = encodeURIComponent(((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host) + '/auth/');
/**
 * Builds a config for the MeControl component.
 */
export const getMeControlConfig = ({ appId, signIn, signOut, themeType = 'dark', supportMsa = true, getRememberedAccounts, }) => ({
    apiGeneration: 'GEN2',
    containerId: 'meControl',
    authProviderConfig: msalJsAuthConfig({
        appId,
        signIn,
        signOutFromApp: signOut,
        supportMsa,
        getRememberedAccounts,
    }),
    primaryUXConfig: {
        //TODO: compressed isn't actually a valid theme type.  what should it be instead?
        //@ts-ignore
        displayModes: [{ type: 'compressed', widthBreakpoint: 1024 }],
        headerTheme: {
            type: themeType,
        },
        theme: {
            type: themeType,
        },
    },
});
const msalJsAuthConfig = (_a) => {
    var { appId, supportMsa } = _a, rest = __rest(_a, ["appId", "supportMsa"]);
    return (Object.assign(Object.assign({}, rest), { 
        // Provider type
        type: supportMsa ? 'msalJsWithMsa' : 'msalJsAadOnly', signInExperienceTypes: 1, 
        // Remembered accounts
        aad: {
            signOutUrl: `https://login.microsoftonline.com/uxlogout?appid=${appId}&wreply=${wreply}&shouldForgetUser=false`,
            signOutAndForgetUrl: `https://login.microsoftonline.com/uxlogout?appid=${appId}&wreply=${wreply}&shouldForgetUser=true`,
            forgetUrl: 'https://login.microsoftonline.com/forgetuser',
            rememberedAccountsUrl: `https://login.microsoftonline.com/savedusers?appid=${appId}&wreply=${wreply}`,
        } }));
};
